import { render, staticRenderFns } from "./ServicePage.vue?vue&type=template&id=5e585e22&scoped=true"
import script from "./ServicePage.vue?vue&type=script&lang=js"
export * from "./ServicePage.vue?vue&type=script&lang=js"
import style0 from "./ServicePage.vue?vue&type=style&index=0&id=5e585e22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e585e22",
  null
  
)

export default component.exports